import { useMemo } from "react";
import merge from "lodash/merge";
import DefaultColumnRenderers from "components/common/EntityDataTable/DefaultColumnRenderers";
const useColumnRenderers = (columnSchemas, customColumnRenderers) => useMemo(() => {
  const renderers = merge({}, DefaultColumnRenderers, customColumnRenderers);
  return Object.fromEntries(
    columnSchemas.map(({ id, type }) => {
      var _a, _b;
      const typeRenderer = (_a = renderers.types) == null ? void 0 : _a[type];
      const attributeRenderer = (_b = renderers.attributes) == null ? void 0 : _b[id];
      const columnRenderer = merge({}, typeRenderer, attributeRenderer);
      return [id, columnRenderer];
    })
  );
}, [columnSchemas, customColumnRenderers]);
export default useColumnRenderers;
